var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "mode",
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "商品明細選択",
        top: "5vh",
        visible: _vm.dialogVisible,
        "show-close": false,
        width: "900px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        opened: _vm.opened,
        close: _vm.close,
      },
    },
    [
      _c(
        "vab-query-form-mode",
        {
          staticClass: "dpform noborder",
          attrs: {
            model: _vm.queryForm,
            rules: _vm.rules,
            "enable-query-save": false,
            size: "mini",
            "label-position": "left",
            "label-width": "180px",
          },
          on: { search: _vm.onSearch },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c("el-form-item", { attrs: { label: "商品" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.goodslists.length == 1
                              ? _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.goodslists[0].itmcd,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.goodslists[0], "itmcd", $$v)
                                    },
                                    expression: "goodslists[0].itmcd",
                                  },
                                })
                              : _vm.goodslists.length > 1
                              ? _c("el-input", {
                                  class: [
                                    _vm.goodslists.length > 1 ? "multiple" : "",
                                  ],
                                  attrs: { value: "<複数>", disabled: "" },
                                })
                              : _c("el-input", {
                                  attrs: { value: "", disabled: "" },
                                }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 18 } },
                          [
                            _vm.goodslists.length == 1
                              ? _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.goodslists[0].itmnm,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.goodslists[0], "itmnm", $$v)
                                    },
                                    expression: "goodslists[0].itmnm",
                                  },
                                })
                              : _vm.goodslists.length > 1
                              ? _c("el-input", {
                                  class: [
                                    _vm.goodslists.length > 1 ? "multiple" : "",
                                  ],
                                  attrs: { value: "<複数>", disabled: "" },
                                })
                              : _c("el-input", {
                                  attrs: { value: "", disabled: "" },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 2 } },
                [
                  _c(
                    "el-popover",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.goodslists.length > 1,
                          expression: "goodslists.length > 1",
                        },
                      ],
                      attrs: { placement: "bottom", trigger: "click" },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.goodslists,
                            border: "",
                            stripe: "",
                            "max-height": "300",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              width: "80",
                              property: "itmcd",
                              "header-align": "center",
                              label: "商品CD",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              width: "300",
                              "header-align": "center",
                              property: "itmnm",
                              label: "商品名",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "more_box flex_center flex_center_align more_change_box",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "inner_box flex_center flex_center_align",
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "sel" },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 11 } },
                [
                  _c("vab-input", {
                    attrs: {
                      prop: "itmdtlcd",
                      label: "商品明細名CD",
                      maxlength: "3",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 11 } },
                [
                  _c("vab-input", {
                    attrs: {
                      prop: "itmdtlnmk",
                      label: "商品明細名(半角ｶﾅ)",
                      maxlength: "50",
                      validate: "halfKana",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "m20" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("vab-table", {
                ref: "table",
                attrs: {
                  "api-url": "/api/mitmdtlp/query",
                  columns: _vm.columns,
                  "custom-config": false,
                  "multi-select": _vm.multiSelect,
                  height: "350",
                  "init-params": _vm.queryForm,
                  "query-params": _vm.queryForm,
                  "row-key": _vm.getRowKey,
                  "enable-init": false,
                },
                on: { "selection-change": _vm.setSelectRows },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [
              _c(
                "el-button",
                { staticClass: "cancel", on: { click: _vm.close } },
                [_vm._v("キャンセル")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }